export default "__VITE_ASSET__CWDE1JBW__"